import { render } from "./RegisterPopup.vue?vue&type=template&id=50cc8994&scoped=true&ts=true"
import script from "./RegisterPopup.vue?vue&type=script&lang=ts"
export * from "./RegisterPopup.vue?vue&type=script&lang=ts"

import "./RegisterPopup.vue?vue&type=style&index=0&id=50cc8994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc8994"]])

export default __exports__